import { inject, observer } from 'mobx-react';
import React, { Component, PureComponent, Fragment } from 'react';
import * as Outcomes from '~/web-frontend-components/line/Outcomes';
import { PrimaryStatisticalCategories, SecondaryStatisticalCategories } from './additionalCategories';

class Item extends PureComponent {
   render() {
      const { check, name, onClick, count } = this.props;
      return (
         <div className={`g-a-c-i ${check ? 'g-a-c-i-s' : null} ${count ? '' : 'g-a-c-i-nh'}`} onClick={onClick} >
            <span dangerouslySetInnerHTML={{ __html: name }}></span>
            {count ? <span className="g-a-c-i-t-c">{count}</span> : null}
         </div>
      );
   }
}

@inject('lineStore')
@observer
class Filters extends Component {
   handleClick = (id) => {
      this.props.lineStore.line.setfilterTable(this.props.statisticalGameID, id);
   };

   render() {
      const {
         id,
         statisticalGameID,
         hasStatisticalCategories,
         isActiveSecondaryStatisticalCategories,
      } = this.props;

      const { filter, order } = this.props.lineStore.line.filterTables.get(statisticalGameID) || {};
      if (!filter) {
         return null;
      }

      const result = [];
      order.forEach(item => {
         const { name, count, select } = filter[item];
         result.push(<Item key={item} count={count} name={name} check={select} id={item} onClick={() => this.handleClick(item)} />);
      });

      return (
        <div className="g-a-c-cont">
           {hasStatisticalCategories && <PrimaryStatisticalCategories gameID={id} />}
           {this.props.lineStore.line.statisticalCategoriesLoading.includes(id)
             ? <div className="loader-ross" />
             : isActiveSecondaryStatisticalCategories
               ? <SecondaryStatisticalCategories gameID={id} />
               : result
           }
           <div className="g-a-t-c">
           </div>
        </div>
      );
   }
}

@inject('lineStore', 'dictStore')
@observer
export default class TableDopFilter extends Component {

   handleUpdate = (updatedGameID) => {
      const lineStore = this.props.lineStore.line;
      const statisticalCategoryID = lineStore.getActiveStatisticalCategoryID(this.props.id);
      if (updatedGameID && updatedGameID !== `${statisticalCategoryID}`) { return; }
      this.setState({ upd: `${Date.now()}` });
   }

   render() {
      const lineStore = this.props.lineStore.line;
      const statisticalCategories = lineStore.statisticalCategories.get(this.props.id) || [];
      const statisticalGameID = lineStore.getActiveStatisticalCategoryID(this.props.id);
      const isActiveSecondaryCategories = (statisticalCategories.find(({ categories }) => typeof categories !== 'undefined') || {}).isActive || false;
      return <Filters
         id={this.props.id}
         statisticalGameID={statisticalGameID}
         hasStatisticalCategories={statisticalCategories.length > 0}
         isActiveSecondaryStatisticalCategories={isActiveSecondaryCategories}
      />
   }
}



// WEBPACK FOOTER //
// ./src/components/line/lineTableFilter.js